// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

// const Contact = () => {
//   return (
//     <>
//     <section style={{ padding: "80px 0", background: "#FFFFFF",  marginTop:"30px"}}>
//       <Container>
//         <h2
//           className="text-center mb-5"
//           style={{
//             fontSize: "32px",
//             fontWeight: "700",
//             fontFamily: "Montserrat, sans-serif",
//           }}
//         >
//           Contact Us
//         </h2>

//         <Row className="justify-content-center">
       
//           <Col lg={5} md={12} className="mb-4">
//             <div className="mb-4">
//               <h4>Get in Touch</h4>
//               <p>
//                 We'd love to hear from you! Send us a message or reach out via
//                 phone or email.
//               </p>
//             </div>

//             <div className="mb-3 d-flex align-items-start">
//               <FaMapMarkerAlt size={20} className="me-2 mt-1" />
//               <span>
//                 39, Mahuwari, Hanswahini Road, Near ITI Factory, Naini,
//                 Prayagraj, Uttar Pradesh
//               </span>
//             </div>

//             <div className="mb-3 d-flex align-items-center">
//               <FaPhoneAlt size={20} className="me-2" />
//               <span>
//                 8882062122 <br /> 9450609827
//               </span>
//             </div>

//             <div className="mb-3 d-flex align-items-center">
//               <FaEnvelope size={20} className="me-2" />
//               <span>sangamguesthouse2026@gmail.com</span>
//             </div>
//           </Col>

          
//           <Col lg={6} md={12}>
//             <Form>
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <Form.Control type="text" placeholder="Your Name" />
//                 </Col>
//                 <Col md={6}>
//                   <Form.Control type="email" placeholder="Your Email" />
//                 </Col>
//               </Row>
//               <Form.Group className="mb-3">
//                 <Form.Control
//                   as="textarea"
//                   rows={5}
//                   placeholder="Your Message"
//                 />
//               </Form.Group>
//               <Button
//                 type="submit"
//                 style={{
//                   backgroundColor: "#ff3b1f",
//                   border: "none",
//                   padding: "10px 28px",
//                 }}
//               >
//                 Send Message
//               </Button>
//             </Form>
//           </Col>
//         </Row>
//       </Container>
//     </section>

//     <div style={{ margin: "20px 20px 40px" }}>
//   <iframe
//     title="Google Map"
//     src="https://www.google.com/maps?q=Mahuwari,Hanswahini%20Road,Naini,Prayagraj,Uttar%20Pradesh&output=embed"
//     width="100%"
//     height="350"
//     style={{
//       border: 0,
//       borderRadius: "10px",
//     }}
//     loading="lazy"
//     referrerPolicy="no-referrer-when-downgrade"
//   ></iframe>
// </div>
//     </>
//   );
// };

// export default Contact;

// import React, { useRef } from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// // import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import emailjs from "@emailjs/browser";

// const Contact = () => {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm(
//         "service_t53zr2g",
//         "template_tocm6ei",
//         form.current,
//         "WfRm2rD0UdjNIh3Y6"
//       )
//       .then(
//         () => {
//           alert("Message sent successfully!");
//           form.current.reset();
//         },
//         (error) => {
//           alert("Failed to send message");
//           console.log(error.text);
//         }
//       );
//   };

//   return (
//     <>
//       <section
//         style={{
//           padding: "80px 0",
//           background: "#FFFFFF",
//           marginTop: "30px",
//         }}
//       >
//         <Container>
//           <h2
//             className="text-center mb-5"
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//             }}
//           >
//             Contact Us
//           </h2>

//           <Row className="justify-content-center">
//             <Col lg={5} md={12} className="mb-4">
//               <h4>Get in Touch</h4>
//              <p>
//   Contact us for bookings, events, or any queries—we’re happy to assist you.
// </p>
//             </Col>

//             <Col lg={6} md={12}>
//               <Form ref={form} onSubmit={sendEmail}>
//                 <Row className="mb-3">
//                   <Col md={6}>
//                     <Form.Control
//                       type="text"
//                       name="user_name"
//                       placeholder="Your Name"
//                       required
//                     />
//                   </Col>

//                   <Col md={6}>
//                     <Form.Control
//                       type="email"
//                       name="user_email"
//                       placeholder="Your Email"
//                       required
//                     />
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3">
//                   <Form.Control
//                     as="textarea"
//                     rows={5}
//                     name="message"
//                     placeholder="Your Message"
//                     required
//                   />
//                 </Form.Group>

//                 <Button
//                   type="submit"
//                   style={{
//                     backgroundColor: "#ff3b1f",
//                     border: "none",
//                     padding: "10px 28px",
//                   }}
//                 >
//                   Send Message
//                 </Button>
//               </Form>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default Contact;


// import React, { useRef } from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import emailjs from "@emailjs/browser";

// const Contact = () => {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm(
//         "service_t53zr2g",
//         "template_tocm6ei",
//         form.current,
//         "WfRm2rD0UdjNIh3Y6"
//       )
//       .then(
//         () => {
//           alert("Message sent successfully!");
//           form.current.reset();
//         },
//         (error) => {
//           alert("Failed to send message");
//           console.log(error.text);
//         }
//       );
//   };

//   return (
//     <section
//       style={{
//         padding: "80px 0",
//         background: "#FFFFFF",
//         marginTop: "30px",
//       }}
//     >
//       <Container>
//         <h2
//           className="text-center mb-5"
//           style={{
//             fontSize: "32px",
//             fontWeight: "700",
//           }}
//         >
//           Contact Us
//         </h2>

//         <Row className="justify-content-center">
          
//           {/* Left Side */}
//           <Col lg={5} md={12} className="mb-4">
//             <h4>Get in Touch</h4>
//             <p className="text-muted mb-4">
//               We'd love to hear from you! Reach out today.
//             </p>

//             <div className="mb-3 d-flex align-items-center">
//               <FaEnvelope className="me-2" />
//               <span>sangamguesthouse2026@gmail.com</span>
//             </div>

//             <div className="mb-3 d-flex align-items-center">
//               <FaPhoneAlt className="me-2" />
//               <span>8882062122, 9450609827</span>
//             </div>

//             <div className="mb-3 d-flex align-items-center">
//               <FaMapMarkerAlt className="me-2" />
//               <span>
//                 39, Mahuwari, Hanswahini road, Near ITI factory, Naini,
//                 Prayagraj, Uttar Pradesh
//               </span>
//             </div>
//           </Col>

          
//           <Col lg={6} md={12}>
//             <Form ref={form} onSubmit={sendEmail}>
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <Form.Control
//                     type="text"
//                     name="user_name"
//                     placeholder="Your Name"
//                     required
//                   />
//                 </Col>

//                 <Col md={6}>
//                   <Form.Control
//                     type="email"
//                     name="user_email"
//                     placeholder="Your Email"
//                     required
//                   />
//                 </Col>
//               </Row>

//               <Form.Group className="mb-3">
//                 <Form.Control
//                   as="textarea"
//                   rows={5}
//                   name="message"
//                   placeholder="Your Message"
//                   required
//                 />
//               </Form.Group>

//               {/* <Button
//                 type="submit"
//                 style={{
//                   backgroundColor: "#ff3b1f",
//                   border: "none",
//                   padding: "10px 28px",
//                 }}
//               >
//                 Send Message
//               </Button> */}

//               <Button
//   type="submit"
//   style={{
//     backgroundColor: "#ff3b1f",
//     border: "none",
//     padding: "10px 28px",
//     transition: "0.3s",
//   }}
//   onMouseEnter={(e) => (e.target.style.backgroundColor = "#ff6a4d")}
//   onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff3b1f")}
// >
//   Send Message
// </Button>
//             </Form>
//           </Col>

//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default Contact;


import React, { useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_t53zr2g",
        "template_tocm6ei",
        form.current,
        "WfRm2rD0UdjNIh3Y6"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message");
          console.log(error.text);
        }
      );
  };

  return (
    <section
      style={{
        padding: "80px 0",
        background: "#FFFFFF",
        marginTop: "30px",
      }}
    >
      <Container>
        <h2
          className="text-center mb-5"
          style={{
            fontSize: "32px",
            fontWeight: "700",
          }}
        >
          Contact Us
        </h2>

        <Row className="justify-content-center">
          {/* Left Side */}
          <Col lg={5} md={12} className="mb-4">
            <h4>Get in Touch</h4>
            <p className="text-muted mb-4">
              We'd love to hear from you! Reach out today.
            </p>

            <div className="mb-3 d-flex align-items-center">
              <FaEnvelope className="me-2" />
              <span>sangamguesthouse2026@gmail.com</span>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <FaPhoneAlt className="me-2" />
              <span>8882062122, 9450609827</span>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <FaMapMarkerAlt className="me-2" />
              <span>
                39, Mahuwari, Hanswahini road, Near ITI factory, Naini,
                Prayagraj, Uttar Pradesh-211010
              </span>
            </div>
          </Col>

       
          <Col lg={6} md={12}>
            <Form ref={form} onSubmit={sendEmail}>
                   <Form.Group className="mb-3">
                              <Form.Label>Name</Form.Label>
                              <Form.Control type="text" name="user_name" placeholder="Enter your name" required />
                            </Form.Group>
              
                            <Form.Group className="mb-3">
                              <Form.Label>Email</Form.Label>
                              <Form.Control type="email" name="user_email" placeholder="Enter your email" required/>
                            </Form.Group>
              
                            <Form.Group className="mb-3">
                              <Form.Label>Message</Form.Label>
                            <Form.Control as="textarea" rows={4} name="message" placeholder="Type your message" required/>
                            </Form.Group>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#ff3b1f",
                  border: "none",
                  padding: "10px 28px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ff6a4d")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#ff3b1f")
                }
              >
                Send Message
              </Button>
            </Form>
          </Col>
        </Row>

    
        <Row className="mt-5">
          <Col>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps?q=Mahuwari%20Naini%20Prayagraj&output=embed"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: "10px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;